/* ==========================================================================
   Input > Object
   ========================================================================== */

const input = {
    /* Enable */
    enable: function Fn() {
        this.element.classList.remove(this.config.css.disabled);
        this.getInput().disabled = false;

        return this;
    },

    /* Disable */
    disable: function Fn() {
        this.element.classList.add(this.config.css.disabled);
        this.getInput().disabled = true;

        return this;
    },

    /* Display */
    show: function Fn() {
        this.element.classList.remove(this.config.css.hidden);

        return this;
    },

    /* Hide */
    hide: function Fn() {
        this.element.classList.add(this.config.css.hidden);

        return this;
    },

    /* Is selectable -> input is of write type */
    isSelectable: function Fn() {
        return this.getInput().type === 'text';
    },

    /* Is active */
    isActive: function Fn() {
        return this.config.isActive;
    },

    /* Set active */
    setActive: function Fn() {
        /* Styling */
        this.element.classList.add(this.config.css.active);

        /* Set status  */
        this.config.isActive = true;

        return this;
    },

    /* Remove active */
    removeActive: function Fn() {
        /* Styling */
        this.element.classList.remove(this.config.css.active);

        /* Set status  */
        this.config.isActive = false;

        return this;
    },

    /* Has error */
    hasError: function Fn() {
        return this.error;
    },

    /* Set valid */
    setValid: function Fn() {
        this.element.classList.remove(this.config.css.error);
        this.element.classList.add(this.config.css.valid);

        /* Set validation to state */
        this.error = false;

        return this;
    },

    /* Set error */
    setError: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.add(this.config.css.error);

        /* Set error to state */
        this.error = true;

        return this;
    },

    /* Reset status */
    resetStatus: function Fn() {
        this.element.classList.remove(this.config.css.valid);
        this.element.classList.remove(this.config.css.error);

        /* Reset validation to state */
        this.error = false;

        return this;
    },

    /* Pairing label */
    setPairing: function Fn() {
        if (this.element.querySelector('label')) {
            this.getInput().setAttribute('id', this.id);
            this.getLabel().setAttribute('for', this.id);
        }

        return this;
    },

    /* Get input */
    getInput: function Fn() {
        return this.element.querySelector('input');
    },

    /* Get label */
    getLabel: function Fn() {
        return this.element.querySelector('label');
    },

    /* Get value */
    get: function Fn() {
        return this.getInput().value;
    },

    /* Set value */
    set: function Fn(value, trigger = true) {
        this.value = value;
        this.getInput().setAttribute('value', value);
        this.getInput().value = value;

        if (trigger) this.onChange(this);

        return this;
    },

    /* On change */
    onChange: function Fn(event = false) {
        /* Get track of the new value in the instance based on the input one */
        if (this.value !== this.getInput().value) this.set(this.getInput().value, false);

        /* Fire external callbacks */
        if (this.config.onChange.length > 0) this.config.onChange.forEach(item => item.call(this, this, event));

        return this;
    },

    /* On Focus In */
    onFocusIn: function Fn() {
        /* Not make useless changes */
        if (this.get().length > 0 && this.isActive()) return this;

        this.setActive();
    },

    /* On Focus Out */
    onFocusOut: function Fn() {
        /* Not make useless changes */
        if (this.get().length > 0 && this.isActive()) return this;

        this.removeActive();
    },

    /* On Click */
    onClick: function Fn() {
        /* Use this method instead of select(), to allow safari work */
        if (this.isSelectable() && this.config.autoSelect) this.getInput().setSelectionRange(0, this.get().length);
    },

    /* Add event listener */
    addEventListener: function Fn() {
        /* Bind events */
        this.bindEvents();

        /* On click */
        this.getInput().addEventListener('click', this.onClick);

        /* On change */
        this.getInput().addEventListener('change', this.onChange);

        /* On focus in */
        this.getInput().addEventListener('focusin', this.onFocusIn);

        /* On focus out */
        this.getInput().addEventListener('focusout', this.onFocusOut);

        return this;
    },

    /* Remove event listener */
    removeEventListener: function Fn() {
        /* On click */
        this.getInput().removeEventListener('click', this.onClick);

        /* On change */
        this.getInput().removeEventListener('change', this.onChange);

        /* On focus in */
        this.getInput().removeEventListener('focusin', this.onFocusIn);

        /* On focus out */
        this.getInput().removeEventListener('focusout', this.onFocusOut);

        return this;
    },

    /* Bind events */
    bindEvents: function Fn() {
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);

        return this;
    },

    /* Init */
    init: function Fn() {
        /* Connect the label in case it has it with its input */
        this.setPairing();

        /* Adding listener */
        if (this.config.domEvents) this.addEventListener();

        /* In case we have init value, set active status */
        if (this.get().length > 1) this.setActive();
    }
};

module.exports = input;
